import moment from 'moment';

/**
 * Calcula as horas úteis entre duas datas, considerando:
 * - Horário comercial: 08:00 às 18:00 (10h úteis/dia)
 * - Finais de semana: Sábado e Domingo são ignorados
 * - Feriados: Lista de EventoGlobal (opcional)
 */
export const calculateBusinessHoursBetween = (start, end, holidays = []) => {
    if (!start || !end) return 0;
    
    let isNegative = moment(start).isAfter(end);
    let current = isNegative ? moment(end) : moment(start);
    const target = isNegative ? moment(start) : moment(end);
    
    let businessMinutes = 0;
    
    // Preparar feriados como intervalos de moment para performance
    const holidayIntervals = holidays.map(h => {
        const parseDate = (d, t) => {
            if (Array.isArray(d) && Array.isArray(t)) {
                return moment([d[0], d[1] - 1, d[2], t[0], t[1], t[2] || 0]);
            }
            if (typeof d === 'string' && typeof t === 'string') {
                return moment(`${d} ${t}`);
            }
            // Caso venha como string ISO mas em campos separados
            return moment(`${d} ${t}`);
        };
        return {
            start: parseDate(h.data_inicial, h.hora_inicial),
            end: parseDate(h.data_final, h.hora_final)
        };
    }).filter(interval => interval.start.isValid() && interval.end.isValid());

    while (current.isBefore(target)) {
        const dayOfWeek = current.day();
        const hour = current.hour();
        
        const isWeekend = (dayOfWeek === 0 || dayOfWeek === 6);
        const isOutsideBusinessHours = (hour < 8 || hour >= 18);
        
        let isHoliday = false;
        if (holidayIntervals.length > 0) {
            isHoliday = holidayIntervals.some(interval => 
                current.isSameOrAfter(interval.start) && current.isBefore(interval.end)
            );
        }
        
        if (!isWeekend && !isOutsideBusinessHours && !isHoliday) {
            // Se faltar menos de 1 hora para o target, adiciona apenas o restante
            const nextHour = moment(current).add(1, 'hour').startOf('hour');
            if (nextHour.isAfter(target)) {
                businessMinutes += target.diff(current, 'minutes');
                current = moment(target);
            } else {
                // Se o início não for hora cheia, calcula até a próxima hora
                const minutesToNextHour = 60 - current.minutes();
                if (minutesToNextHour < 60 && minutesToNextHour > 0) {
                   businessMinutes += minutesToNextHour;
                   current.add(minutesToNextHour, 'minutes');
                } else {
                    businessMinutes += 60;
                    current.add(1, 'hour');
                }
            }
        } else {
            // Pula para a próxima hora ou início do próximo dia útil
            if (isOutsideBusinessHours && hour >= 18) {
                current.add(1, 'day').hour(8).startOf('hour');
            } else if (isOutsideBusinessHours && hour < 8) {
                current.hour(8).startOf('hour');
            } else if (isWeekend) {
                current.add(1, 'day').startOf('day');
            } else if (isHoliday) {
                // Encontra o fim do feriado e pula pra lá
                // Simplificação: apenas pula 1 hora
                current.add(1, 'hour');
            } else {
                current.add(1, 'hour');
            }
        }
    }
    
    return isNegative ? -businessMinutes : businessMinutes;
};

export const formatBusinessDuration = (minutes) => {
    const isNegative = minutes < 0;
    const absMinutes = Math.abs(minutes);
    const h = Math.floor(absMinutes / 60);
    const m = absMinutes % 60;
    return `${isNegative ? '-' : ''}${h}h ${m}m`;
};
